import { useEffect, useState } from "react";
import useUserProfile from "../../../customHooks/useUserProfile";

import EditModal from "./EditModal"; // Import the new modal
import Profile from "../../../components/partials/application-portal/Profile";

const LOCAL_STORAGE_KEY = "applicationFormData";

const initialData = {
  name: "",
  birthday: "",
  gender: "",
  email: "",
  password: "",
  phoneNumber: "",
  whatsappNumber: "",
  residentialAddress: "",
  postalAddress: "",
  nationality: "",
  momoNumber: "",
  bankAccountNumber: "",
  tertiary: "",
  secondary: "",
  guarantor1: "",
  guarantor2: "",
  admissionLetter: "",
  ghanaCard: "",
};

function ProfilePage() {
  const [userProfile] = useUserProfile();
  const [formData, setFormData] = useState(() => {
    const savedData = localStorage.getItem(LOCAL_STORAGE_KEY);
    return savedData ? JSON.parse(savedData) : initialData;
  });

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [currentTable, setCurrentTable] = useState("");
  const [currentData, setCurrentData] = useState({});

  const handleUploadDocument = (
    event: React.ChangeEvent<HTMLInputElement>,
    field: string
  ) => {
    const file = event.target.files?.[0];
    if (file) {
      setFormData((prevData: any) => ({
        ...prevData,
        [field]: file.name, // Store the entire file object
      }));
    }
  };

  const handleOpenEditModal = (table: string) => {
    setCurrentTable(table);

    // Set currentData based on the selected table
    switch (table) {
      case "Basic":
        setCurrentData({
          name: formData.name,
          birthday: formData.birthday,
          gender: formData.gender,
        });
        break;
      case "Contact":
        setCurrentData({
          email: formData.email,
          phoneNumber: formData.phoneNumber,
          whatsappNumber: formData.whatsappNumber,
          residentialAddress: formData.residentialAddress,
          postalAddress: formData.postalAddress,
          nationality: formData.nationality,
        });
        break;
      case "Password":
        setCurrentData({
          password: formData.password,
        });
        break;
      case "Payment":
        setCurrentData({
          momoNumber: formData.momoNumber,
          bankAccountNumber: formData.bankAccountNumber,
        });
        break;
      case "Education":
        setCurrentData({
          tertiary: formData.tertiary,
          secondary: formData.secondary,
        });
        break;
      default:
        setCurrentData({});
    }

    setIsEditModalOpen(true);
  };

  const handleSaveData = (data: any) => {
    setFormData((prev: any) => ({ ...prev, ...data }));
    localStorage.setItem(
      LOCAL_STORAGE_KEY,
      JSON.stringify({ ...formData, ...data })
    );
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    const endpoint = "/api/api/users/users/1";
    try {
      const response = await fetch('${APPLICATION_SERVICE_API_BASE_URL}${endpoint}', {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const result = await response.json();
      alert("Application submitted successfully!");
      console.log(result);
      localStorage.removeItem(LOCAL_STORAGE_KEY);
    } catch (error) {
      console.error("There was a problem with the fetch operation:", error);
      alert(
        "There was an error submitting your application. Please try again."
      );
    }
  };

  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = "";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return (
    <div className="">
      <Profile
        title={"Application"}
        description={"Profile"}
        subtitle={"Make changes to your profile here."}
        userProfile={{
          name: userProfile.name,
          imageUrl: userProfile.imageUrl,
        }}
        onSubmit={handleSubmit}
        onUploadDoc={handleUploadDocument}
        basicTable={{
          columns: [
            { Header: "Field", accessor: "field" },
            { Header: "Name", accessor: "name" },
          ],
          data: [
            {
              field: "Name",
              name: <span>{formData.name}</span>,
            },
            {
              field: "Birthday",
              name: <span>{formData.birthday}</span>,
            },
            {
              field: "Gender",
              name: <span>{formData.gender}</span>,
            },
          ],
        }}
        contactTable={{
          columns: [
            { Header: "Field", accessor: "field" },
            { Header: "Name", accessor: "name" },
          ],
          data: [
            {
              field: "Email",
              name: <span>{formData.email}</span>,
            },
            {
              field: "Active Phone Number",
              name: <span>{formData.phoneNumber}</span>,
            },
            {
              field: "WhatsApp Number",
              name: <span>{formData.whatsappNumber}</span>,
            },
            {
              field: "Residential Address",
              name: <span>{formData.residentialAddress}</span>,
            },
            {
              field: "Postal Address",
              name: <span>{formData.postalAddress}</span>,
            },
            {
              field: "Nationality",
              name: <span>{formData.nationality}</span>,
            },
          ],
        }}
        passwordTab={{
          columns: [
            { Header: "Field", accessor: "field" },
            { Header: "Name", accessor: "name" },
          ],
          data: [
            {
              field: "Password",
              name: <span>{formData.password}</span>,
            },
          ],
        }}
        paymentTable={{
          columns: [
            { Header: "Field", accessor: "field" },
            { Header: "Name", accessor: "name" },
          ],
          data: [
            {
              field: "Momo Number",
              name: <span>{formData.momoNumber}</span>,
            },
            {
              field: "Bank Account Number",
              name: <span>{formData.bankAccountNumber}</span>,
            },
          ],
        }}
        onEditBasicTable={() => handleOpenEditModal("Basic")}
        onEditContactTable={() => handleOpenEditModal("Contact")}
        onEditPasswordTab={() => handleOpenEditModal("password")}
        onEditPaymentTable={() => handleOpenEditModal("Payment")}
      />
      <EditModal
        isOpen={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
        onSave={handleSaveData}
        data={currentData}
        title={`${currentTable} Info`}
      />
    </div>
  );
}

export default ProfilePage;
